module.exports = __webpack_public_path__ + "img/GR034.eb187b2f.png";